import { render, staticRenderFns } from "./heroBlock.vue?vue&type=template&id=4605a20d&scoped=true"
import script from "./heroBlock.vue?vue&type=script&lang=js"
export * from "./heroBlock.vue?vue&type=script&lang=js"
import style0 from "./heroBlock.vue?vue&type=style&index=0&id=4605a20d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605a20d",
  null
  
)

export default component.exports